import { ActionTree } from 'vuex';
import { RootState, SingleFilter } from '@/store/types';
import { ProposalState } from './types';
import api from '@/api';
import * as proposalRequests from '@/api/requests/proposal/proposals';
import { DOWNLOAD_SAMPLE_AS_PDF, GET_SAMPLE_PDF_AS_LINK } from '@/api/requests/proposal/samples';

export const actions: ActionTree<ProposalState, RootState> = {

    /**
     * Send the proposal with email to the customer assigned to the proposal.
     *
     * @param proposalId
     */
    async sendToAssignedCustomer({}, proposalId: number) {
        const response = await api.call(proposalRequests.SEND_TO_ASSIGNED_CUSTOMER(proposalId, {}));
    },

    /**
     * Send the proposal with email to the customer assigned to the proposal.
     *
     * @param proposalId
     */
    async sendToChosenAddresses({}, params: {proposalId: number, mailAddresses: Array<{email: String, sendType: String}>, addressee: String}) {
        const response = await api.call(proposalRequests.SEND_TO_CHOSEN_ADDRESSES(params.proposalId, params.mailAddresses, params.addressee));
        return response;
    },

    /**
     * Get proposal as pdf.
     *
     * @param proposalId
     */
    async downloadProposalAsPdf({}, params: { proposalId: number, addressee: string}) {
        const response = await api.call(proposalRequests.DOWNLOAD_PROPOSAL_AS_PDF(params.proposalId, {addressee: params.addressee}));
        return response;
    },

    /**
     * Get sample as pdf.
     *
     * @param sampleId
     */
    async downloadSampleAsPdf({}, sampleId: number) {
        const response = await api.call(DOWNLOAD_SAMPLE_AS_PDF(sampleId, {}));
        return response;
    },

    /**
     * Get proposal's pdf as link.
     *
     * @param proposalId
     */
    async getProposalPdfAsLink({}, params: {addressee: string, proposalId: number}) {
        const response = await api.call(proposalRequests.GET_PROPOSAL_PDF_AS_LINK(params.proposalId, {addressee: params.addressee}));
        return response;
    },

    /**
     * Get sample's pdf as link.
     *
     * @param sampleId
     */
    async getSamplePdfAsLink({}, sampleId: number) {
        const response = await api.call(GET_SAMPLE_PDF_AS_LINK(sampleId, {}));
        return response;
    },

    /** Filters */
    
    /**
     * Set filters.
     *
     * @param commit
     * @param dispatch
     * @param filters
     */
    setFilters({ commit }, filters: SingleFilter[]) {
        filters.map((filter) => commit('setFilter', filter));
    },

    /**
     * Reset a single filter.
     *
     * @param commit
     * @param key
     */
    resetFilter({ commit }, key: string) {
        commit('resetFilter', key);
    },
};
